import { stringForTrim } from "../utils/common";

export const patternValidator = (pattern, value) => {
  const regExp = new RegExp(pattern);
  return regExp.test(value);
};

export const checkMaxLength = (length = 5, value) => +value <= length;

export const required = value => !!stringForTrim(value);
